<template>
  <div class="section-wrap new-type" id="careers-modal-template">
    <div class="loop-tbl" v-for="(career, index) in careers" :key="career.seq">
      <div class="multi-item-title mt-40" v-if="index === 0">
        <h3 class="section-title ">구직자 경력사항</h3>
        <div class="check-util">
          <div class="check-wrap"><input type="checkbox" id="nopersonal" v-model="careerUseYn" true-value="N" false-value="Y" title="경력사항 없음 선택"><label for="nopersonal"><span>경력사항 없음</span></label></div>
          <button type="button" class="btn btn-line-box btn-sm" @click="reset(index)">
            <i class="ico ico-refresh"></i>
            입력항목 초기화
          </button>
        </div>
      </div>
      <div class="multi-item-title mt-40" v-else>
        <h3 class="section-title ">추가정보{{ index }}</h3>
        <div class="check-util">
          <button type="button" class="btn btn-line-box btn-sm" @click="reset(index)">
            <i class="ico ico-refresh"></i>
            입력항목 초기화
          </button>
          <button type="button" class="btn btn-line-box btn-sm" @click="del(index)">
            <i class="ico ico-trash"></i>
            삭제하기
          </button>
        </div>
      </div>
      <div class="table-wrap" >
        <table class="table-body-only">
          <caption>경력사항 테이블</caption>
          <colgroup class="pc-cell">
            <col style="width: 160px;"/>
            <col/>
          </colgroup>
          <colgroup class="mo-cell">
            <col style="width: 88px;"/>
            <col/>
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">회사/<br class="mo-only">
                단체명<span class="must">*</span>
              </th>
              <td>
                <div class="input-area mo-size wid400">
                  <input type="text" placeholder="입력하세요" v-model="career.compnm" :disabled="isDisabled" title="회사/단체명" @input="limitBytes($event, career, 'compnm', 100, '회사/단체명')"/>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">근무/
                <br class="mo-only">활동<br class="mo-only">기간
              </th>
              <td>
                <div class="input-group period-setting">
                  <div class="start-day">
                    <div class="input-area mo-size">
                      <select name="startYear" id="startYear" title="시작년도선택" v-model="career.stYear" :disabled="isDisabled">
                        <option value="">시작년도 선택</option>
                        <option v-for="year in years" :key="year" :value="year">{{ year }}년</option>
                      </select>
                    </div>
                    <div class="dash">-</div>
                    <div class="input-area mo-size">
                      <select name="startMonth" id="startMonth" title="시작월선택" v-model="career.stMonth" :disabled="isDisabled">
                        <option value="" disabled selected hidden>시작월 선택</option>
                        <option value="01">1월</option>
                        <option value="02">2월</option>
                        <option value="03">3월</option>
                        <option value="04">4월</option>
                        <option value="05">5월</option>
                        <option value="06">6월</option>
                        <option value="07">7월</option>
                        <option value="08">8월</option>
                        <option value="09">9월</option>
                        <option value="10">10월</option>
                        <option value="11">11월</option>
                        <option value="12">12월</option>
                      </select>
                    </div>
                  </div>
                  <div class="dash">~</div>
                  <div class="end-day">
                    <div class="input-area mo-size">
                      <select name="endYear" id="endYear" title="종료년도선택" v-model="career.edYear" :disabled="isDisabled">
                        <option value="">종료년도 선택</option>
                        <option v-for="year in years" :key="year" :value="year">{{ year }}년</option>
                      </select>
                    </div>
                  <div class="dash">-</div>
                  <div class="input-area mo-size">
                    <select name="endMonth" id="endMonth" title="종료월선택" v-model="career.edMonth" :disabled="isDisabled">
                      <option value="" disabled selected hidden>종료월 선택</option>
                      <option value="01">1월</option>
                      <option value="02">2월</option>
                      <option value="03">3월</option>
                      <option value="04">4월</option>
                      <option value="05">5월</option>
                      <option value="06">6월</option>
                      <option value="07">7월</option>
                      <option value="08">8월</option>
                      <option value="09">9월</option>
                      <option value="10">10월</option>
                      <option value="11">11월</option>
                      <option value="12">12월</option>
                    </select>
                  </div>
                </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">직위</th>
              <td>
                <div class="input-area mo-size wid400">
                  <input type="text" placeholder="입력하세요" v-model="career.pos" :disabled="isDisabled" title="직위" @input="limitBytes($event, career, 'pos', 200, '직위')"/>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">담당업무</th>
              <td>
                <div class="input-area mo-size wid400">
                  <input type="text" placeholder="입력하세요" v-model="career.resbiz" :disabled="isDisabled" title="담당업무" @input="limitBytes($event, career, 'resbiz', 200, '담당업무')"/>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Add Resume Card -->
    <div class="flex flex-direction align-items-center mt-40">
      <button type="button" class="add-resume-icon" @click="add" :disabled="isDisabled">
        <i class="ico ico-plus48"></i>
        <p>추가하기</p>
      </button>
      <p>클릭하여 추가 정보를 입력하실 수 있습니다.</p>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import Axios from 'axios';
import { apiHandler, byteLimitMixin } from './resume-common';

export default({
  name: 'careers-modal-template',
  mixins: [byteLimitMixin],
  props: ['careersModal', 'indbankNo'],
  data() {
    return {
      careers: [],
      careerUseYn: 'Y',
      years: [],
      months: [],
      career: {
        compnm: '',
        resbiz: '',
        pos: '',
        carrStde: '',
        carrEdde: '',
        seq: '',
        stYear: '',
        stMonth: '',
        edYear: '',
        edMonth: '',
      },
    };
  },
  computed: {
    isDisabled() {
      return this.careerUseYn === 'N';
    },
  },
  watch: {
    careersModal: {
      handler(newVal) {
        if (newVal) {
          if (this.indbankNo) {
            this.careers = [];
            this.getCareers();
            this.getBasic();
          } else {
            this.add();
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    getCareers() {
      Axios.get(`/api/idb/${this.indbankNo}/careers`).then((response) => {
        if (response.data.success === 'R') {
          if (response.data.data.length === 0) this.add();
          else {
            this.careers = response.data.data.map((career) => {
              const newCareer = {
                ...career,
                stYear: '',
                stMonth: '',
                edYear: '',
                edMonth: '',
              };
              if (career.carrStde) {
                newCareer.stYear = career.carrStde.substr(0, 4);
                newCareer.stMonth = career.carrStde.substr(4, 2);
              }
              if (career.carrEdde) {
                newCareer.edYear = career.carrEdde.substr(0, 4);
                newCareer.edMonth = career.carrEdde.substr(4, 2);
              }
              return newCareer;
            });
          }
        }
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    getBasic() {
      Axios.get(`/api/idb/${this.indbankNo}/basic`).then((response) => {
        if (response.data.success === 'R') {
          this.careerUseYn = response.data.data.careerUseYn;
        }
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    getYearArray() {
      const currentYear = new Date().getFullYear();
      for (let i = 1900; i <= currentYear; i += 1) {
        this.years.push(i);
      }
    },
    updateCareers() {
      if (this.vaildCheck() && confirm('저장 하시겠습니까?')) {
        let careersParam = [];
        if (this.careerUseYn === 'Y') {
          careersParam = this.careers.map((career) => {
            const newItem = { ...career };
            newItem.carrStde = `${career.stYear}${career.stMonth}`;
            newItem.carrEdde = `${career.edYear}${career.edMonth}`;
            return newItem;
          });
        }
        Axios.post(`/api/idb/${this.indbankNo}/careers`, { careerUseYn: this.careerUseYn, careers: careersParam }).then((response) => {
          apiHandler.handleSaveSuccess(response, (res) => {
            // 완성도 업데이트 (올바른 경로로 접근)
            if (res.data && res.data.data.completionRate !== undefined) {
              this.$emit('update:CompletionRate', res.data.data.completionRate);
            }
          });
        }).catch((e) => {
          apiHandler.handleError(e);
        });
      }
    },
    vaildCheck() {
      if (this.careerUseYn === 'N') return true;
      return this.careers.every((career) => {
        if (!career.compnm) {
          alert('회사단체명을 입력해주세요.');
          return false;
        }
        
        if (!career.stYear || !career.stMonth || !career.edYear || !career.edMonth) {
          alert('근무/활동기간을 모두 입력해주세요.');
          return false;
        }

        // 시작 날짜와 종료 날짜 비교
        const startDate = new Date(`${career.stYear}-${career.stMonth}-01`);
        const endDate = new Date(`${career.edYear}-${career.edMonth}-01`);

        if (endDate < startDate) {
          alert('종료 날짜가 시작 날짜보다 이전일 수 없습니다.');
          return false;
        }

        return true;
      });
    },
    add() {
      // 최대 3개로 제한
      if (this.careers.length >= 3) {
        alert('추가정보는 최대 3개까지만 입력 가능합니다.');
        return;
      }

      // 각 경력 항목마다 독립적인 새 객체 생성
      const newCareerItem = {
        compnm: '',
        resbiz: '',
        pos: '',
        carrStde: '',
        carrEdde: '',
        seq: '',
        stYear: '',
        stMonth: '',
        edYear: '',
        edMonth: '',
      };
      this.careers.push(newCareerItem);
    },
    reset(index) {
      const message = '입력하신 내용을 초기화하시겠습니까?';

      if (confirm(message)) {
        // 해당 인덱스에 독립적인 새 객체 생성
        const resetCareerItem = {
          compnm: '',
          resbiz: '',
          pos: '',
          carrStde: '',
          carrEdde: '',
          seq: '',
          stYear: '',
          stMonth: '',
          edYear: '',
          edMonth: '',
        };
        Vue.set(this.careers, index, resetCareerItem);
      }
    },
    del(index) {
      if (confirm('해당 추가정보를 삭제 하시겠습니까?')) {
        this.careers.splice(index, 1);
      }
    },
  },
  mounted() {
    this.getYearArray();
  },
});
</script>



// WEBPACK FOOTER //
// Careers.vue?6ecd1508